var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"listRef",staticClass:"command-k-list",attrs:{"role":"listbox","aria-label":"Suggestions"}},[_c('div',{ref:"heightRef",staticClass:"command-k-sizer"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }